<style lang="scss">
    .search-page{
        .tabs-menu{
            margin-bottom: 30px;
            padding-left: 0px !important;
        }

        .filter-tab{
            color:#595E63;
            font-size: 14px;
            padding-bottom: 5px;
            padding-left: 5px;
            padding-right: 5px;
            margin: 10px;
            cursor: pointer;
        }

        .selected-tab{
            color: #FF5B94 !important;
            border-bottom: 1px solid;
        }

        .featured-genre{
            min-height: 16px !important;
        }

        .margin-tb-10{
            margin-top: 10px !important;
            margin-bottom: 10px !important;
        }

        .view-more-button {
            width: 160px;
            height: 43px;
            box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
            border-radius: 5px;
            background-color: #ff1466;
            color: #ffffff;
            font-size: 14px;
            font-weight: 500;
            margin-top: 10px;
            padding-top: 15px;
        }
    }
</style>

<template>
    <div class="search-page padding">
        <div class="col-xs-12 text-left tabs-menu">
            <!--<span class="filter-tab" :class="{'selected-tab': filter == 'all'}" @click="show('all')">ALL</span>-->
            <span v-if="config.defaultBeatsPage" class="filter-tab" :style="highlightColor(filter == 'beats')"  @click="show('beats')">Beats</span>
            <span v-if="config.songsPage" class="filter-tab" :style="highlightColor(filter == 'songs')"  @click="show('songs')">Songs</span>
            <span v-if="config.soundkitsPage" class="filter-tab" :style="highlightColor(filter == 'soundkits')"  @click="show('soundkits')">Sound Packs</span>
            <span v-if="config.servicesPage" class="filter-tab" :style="highlightColor(filter == 'services')"  @click="show('services')">Services</span>
        </div>
        <div class="row">
            <div v-if="filter == 'beats'">
                <div class="text-center" v-if="loading.beats">
                    <loading-icon></loading-icon>
                </div>
                <beat-container class="tw-mb-2 md:tw-mb-4 lg:tw-mb-5 col-xs-6 col-md-3" v-for="beat in beats" :beat="beat" :show-price="true" :show-download="true" :key="beat.id" :image-size="300"></beat-container>

                <div v-if="!loading.beats && beats.length > 0 && viewMoreBeats" class="col-xs-12">
                    <router-link :to="{path: config.defaultBeatsPage.link, query: {q: $route.query.q}}" class="view-more-button btn pull-right" :style="$mainButtonStyle">View More</router-link>
                </div>
                <div v-if="!loading.beats && beats.length == 0" class="col-xs-12">There are no beats which match your search.</div>
            </div>
            <div v-if="filter == 'soundkits'">
                <div class="text-center" v-if="loading.soundkits">
                    <loading-icon></loading-icon>
                </div>
                <div class="tw-mb-2 md:tw-mb-4 lg:tw-mb-5 col-xs-6 col-md-3" v-for="soundkit in soundkits" :key="soundkit.id" >
                  <soundkit-container :soundkit="soundkit" :show-price="true" :showGenre="true"></soundkit-container>
                </div>
                <div v-if="!loading.soundkits && soundkits.length == 0" class="col-xs-12">There are no sound packs which match your search.</div>
            </div>
            <div v-if="filter == 'songs'">
                <div class="text-center" v-if="loading.songs">
                    <loading-icon></loading-icon>
                </div>
                <song-container class="col-xs-6 col-sm-4 col-md-3 margin-tb-10" v-for="song in songs" :key="song.id" :song="song" :show-price="true" :showGenre="true"></song-container>
                <div v-if="!loading.songs && songs.length == 0" class="col-xs-12">There are no songs which match your search.</div>
            </div>
            <div v-if="filter == 'services'">
                <div class="text-center" v-if="loading.services">
                    <loading-icon></loading-icon>
                </div>
                <div class="tw-mb-2 md:tw-mb-4 lg:tw-mb-5 col-xs-6 col-md-3" v-for="service in services" :key="service.id" >
                    <service-container :service="service"></service-container>
                </div>
                <div v-if="!loading.services && services.length == 0" class="col-xs-12">There are no services which match your search.</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Configure from './../../mixins/configure'
    import Beat from './../../models/beat'
    import Song from './../../models/song'
    import Soundkit from './../../models/soundkit'
    import Playlist from './../../classes/playlist';
    import SoundkitContainer from '../soundkits/list/soundkit-container.vue'
    import BeatContainer from './../beatcontainer.vue'
    import SongContainer from './../songcontainer.vue'
    import LoadingIcon from './../loadingicon.vue'
    import ServiceRepository from '../../mixins/service-repository'
    import Service from "../../models/service";
    import ServiceContainer from "../services/list/service-container";

    export default {

        components : {
            ServiceContainer,
            SoundkitContainer,BeatContainer,SongContainer, LoadingIcon
        },
        mixins: [Configure, ServiceRepository],
        beforeCreate() {
            this.$store.state.playlistManager.setPagePlaylist(new Playlist([], "search"));
            let query = this.$route.query.q;
            if (query != undefined){
                this.$store.commit("searchQuery", {searchQuery: query})
            }
        },
        mounted() {
          const tabs = ['beats', 'soundkits', 'songs', 'services']
          const from = this.$route.query?.from
          if (tabs.includes(from)) {
            this.filter = from
          }
        },
      data() {
            return {
                beats: [],
                soundkits: [],
                songs: [],
                services: [],
                filter: 'beats',
                viewMoreBeats: false,
                beatsRequestCancel: null,
                songsRequestCancel: null,
                soundkitsRequestCancel: null,
                servicesRequestCancel: null,
                loading: {
                    beats: false,
                    songs: false,
                    soundkits: false,
                    services: false,
                }
            }
        },
        computed: {
            searchQuery() {
                return this.$store.state.search
            },
            config() {
                return this.$store.state.currentConfig
            },
            playlistManager() {
                return this.$store.state.playlistManager
            },
        },
        methods: {
            searchBeats() {
                let params = {
                    page: 1,
                    user_id: this.$store.state.user.id,
                    search: this.searchQuery.toLowerCase(),
                    limit: 8
                }

                let vm = this

                return this.$http.get(`${ab.apiUrl}/beats/search`, {
                    params,
                    cancelToken: new this.$httpCancelToken(function executor(e) {
                        vm.beatsRequestCancel = e
                    })
                })
            },
            searchSoundkits() {
                let params = {
                    search: this.searchQuery,
                }

                let vm = this

                return this.$http.get(`${ab.apiUrl}/users/${ab.user.id}/kits`, {
                    params,
                    cancelToken: new this.$httpCancelToken(function executor(e) {
                        vm.soundkitsRequestCancel = e
                    })
                })
            },
            searchSongs() {
                let params = {
                    search: this.searchQuery,
                }

                let vm = this

                return this.$http.get(`${ab.apiUrl}/users/${ab.user.id}/songs`, {
                    params,
                    cancelToken: new this.$httpCancelToken(function executor(e) {
                        vm.songsRequestCancel = e
                    })
                })
            },
            searchServices() {
                let vm = this
                return this.getUserServices(1, 500, {
                    search: this.searchQuery,
                    cancelToken: new this.$httpCancelToken(function executor(e) {
                        vm.servicesRequestCancel = e
                    })
                })
            },
            show(type){
                this.filter =  type;
            },
            cancelRequests() {
                if (this.beatsRequestCancel) this.beatsRequestCancel()
                if (this.songsRequestCancel) this.songsRequestCancel()
                if (this.soundkitsRequestCancel) this.soundkitsRequestCancel()
                if (this.servicesRequestCancel) this.servicesRequestCancel()
            },
            highlightColor(active) {
                if (active) {
                    return this.$highlightColor
                }
                return this.$mainPrimaryTextStyle
            }
        },
        watch : {
            '$route.query.q': {
                handler (val) {
                    this.cancelRequests()

                    let playlist = this.playlistManager.getPagePlaylist()

                    if (this.config.defaultBeatsPage) {
                        this.beats = []
                        this.loading.beats = true
                        this.searchBeats().then(response => {
                            this.beats = Beat.makeArray(response.data.items)
                            this.loading.beats = false
                            if (response.data.cursor.next) {
                                this.viewMoreBeats = true
                            } else {
                                this.viewMoreBeats = false
                            }

                            if (playlist) playlist.addPlaylistItems(this.beats)
                        }).catch((e) => {
                            if (!this.$http.isCancel(e)) {
                                this.loading.beats = false
                                this.viewMoreBeats = false
                            }
                        })
                    }

                    if (this.config.soundkitsPage) {
                        this.soundkits = []
                        this.loading.soundkits = true
                        this.searchSoundkits().then(response => {
                            this.soundkits = Soundkit.makeArray(response.data.items)
                            this.loading.soundkits = false

                            if (playlist) playlist.addPlaylistItems(this.soundkits)
                        }).catch((e) => {
                            if (!this.$http.isCancel(e)) {
                                this.loading.soundkits = false
                            }
                        })
                    }

                    if (this.config.songsPage) {
                        this.songs = []
                        this.loading.songs = true
                        this.searchSongs().then(response => {
                            this.songs = Song.makeArray(response.data.items)
                            this.loading.songs = false

                            if (playlist) playlist.addPlaylistItems(this.songs)
                        }).catch((e) => {
                            if (!this.$http.isCancel(e)) {
                                this.loading.songs = false
                            }
                        })
                    }

                    if (this.config.servicesPage) {
                        this.services = []
                        this.loading.services = true
                        this.searchServices().then(response => {
                            this.services = Service.makeArray(response.data.items)
                            this.loading.services = false
                        }).catch((e) => {
                            if (!this.$http.isCancel(e)) {
                                this.loading.services = false
                            }
                        })
                    }
                },
                immediate: true
            },
        }
    }
</script>
